import { BrokerFeeContainer } from "pages/Application/Recommendation/Recommendation.styles"
import React from "react"

export const BrokerFee = () => {
  return (
    <BrokerFeeContainer>
      <div>
        <span>Mojo's Broker Fee</span>
        <span>£{0}</span>
      </div>
      <p>
        We don't charge you a penny, all our costs are covered by the lender, these fees never
        affect our advice. Our reputation and livelihood depend on us always giving our customers
        the best possible advice.
      </p>
    </BrokerFeeContainer>
  )
}
